import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";
import {withRouterParams} from "../../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class ConnectTiendaNube extends Component {
    static apiCallInProgress = false;

    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        if (ConnectTiendaNube.apiCallInProgress) {
            return;
        }
        ConnectTiendaNube.apiCallInProgress = true;

        // La URL tiene el siguiente formato:
        // https://app.dashbo.io/connect-tienda-nube?code=XXX&state=XXX (state es opcional)
        const urlParams = new URLSearchParams(window.location.search);
        const hasError = urlParams.has('error');
        
        const { t } = this.props;

        // Verificar si hay errores de OAuth en la URL (ej: redirect_uri_mismatch)
        if (hasError) {
            const error = urlParams.get('error');
            const error_description = urlParams.get('error_description');
            
            let errorMessage = '';
            if (error === 'redirect_uri_mismatch') {
                errorMessage = t('tienda_nube_link.error_redirect_uri_mismatch') || 'El redirect_uri no coincide con la configuración. Por favor, contacta al equipo de soporte.';
            } else {
                errorMessage = error_description || error || 'Error de autorización';
            }
            alert(errorMessage);
            this.props.history.push('/agency/conections');
            ConnectTiendaNube.apiCallInProgress = false;
            return;
        }

        const urlParse = new URLQueryStringParser();
        let authorization_code = urlParse.getUrlParams('code');
        let state = urlParse.getUrlParams('state');

        // Validar que el código de autorización exista
        if (!authorization_code) {
            alert(t('tienda_nube_link.error_no_authorization_code') || 'No se recibió el código de autorización');
            this.props.history.push('/agency/conections');
            ConnectTiendaNube.apiCallInProgress = false;
            return;
        }

        // Preparar el payload para el backend (state es opcional)
        const payload = {
            'authorization_code': authorization_code
        };
        
        // Solo incluir state si está presente en la URL
        if (state) {
            payload.state = state;
        }

        // Enviar código y state (si existe) al backend
        new APIClient(API_URL + 'get_access_tokens/tienda_nube/').call('POST', payload).then((data) => {
            // Función helper para extraer mensaje de error de forma segura
            const getErrorMessage = (errorData) => {
                if (!errorData) return 'Error desconocido';
                
                // Si es un string, devolverlo directamente
                if (typeof errorData === 'string') return errorData;
                
                // Si es un objeto, intentar extraer el mensaje
                if (typeof errorData === 'object') {
                    // Intentar diferentes propiedades comunes
                    if (errorData.message && typeof errorData.message === 'string') return errorData.message;
                    if (errorData.error_message && typeof errorData.error_message === 'string') return errorData.error_message;
                    if (errorData.detail && typeof errorData.detail === 'string') return errorData.detail;
                    
                    // Si tiene errors array
                    if (Array.isArray(errorData.errors) && errorData.errors.length > 0) {
                        const firstError = errorData.errors[0];
                        if (typeof firstError === 'string') return firstError;
                        if (firstError && typeof firstError === 'object') {
                            return firstError.message || firstError.detail || String(firstError);
                        }
                    }
                    
                    // Último recurso: convertir a string
                    try {
                        return JSON.stringify(errorData);
                    } catch {
                        return String(errorData);
                    }
                }
                
                return String(errorData);
            };

            if (!data) {
                alert(t('tienda_nube_link.error_unknown') || 'Error desconocido al procesar la conexión');
                this.props.history.push('/agency/conections');
                return;
            }

            if (data.status === 'ERROR') {
                const errorMessage = getErrorMessage(data);
                
                // Manejar error específico de state inválido
                if (errorMessage.includes('Invalid state') || errorMessage.includes('CSRF')) {
                    alert(t('tienda_nube_link.error_invalid_state') || 'Hubo un problema de seguridad. Por favor, intenta conectar tu cuenta de Tiendanube nuevamente desde el inicio.');
                } else {
                    alert(errorMessage);
                }
                
                this.props.history.push('/agency/conections');
            } else if (data.status === 'OK') {
                this.props.history.push('/agency/conections');
                alert(t('tienda_nube_link.account_linked_successfully'))
            } else {
                // Si no tiene status o tiene un status desconocido
                const errorMessage = getErrorMessage(data);
                alert(errorMessage);
                this.props.history.push('/agency/conections');
            }
        }).catch((error) => {
            // Manejar errores de red u otros errores no capturados
            let errorMessage = 'Error al conectar con Tiendanube';
            if (error) {
                if (typeof error === 'string') {
                    errorMessage = error;
                } else if (error.message) {
                    errorMessage = error.message;
                } else {
                    errorMessage = String(error);
                }
            }
            alert(errorMessage);
            this.props.history.push('/agency/conections');
        }).finally(() => {
            ConnectTiendaNube.apiCallInProgress = false;
        });
    }

    render() {
        const { t } = this.props;
        return <Loading message={t('connect_tienda_nube.wait_while_connecting')}/>
    }
}

export default withRouterParams(withTranslation()(ConnectTiendaNube));

